import { reactive, toRefs, nextTick, unref } from 'vue'
import { clone } from '@/common/js/just.js'
import { MEDIAS } from '@/common/js/constants'
import { getTargetingData } from '@/api/manage.model'
import {
  TOUTIAO_AD_MARKETING_SCENE,
  TOUTIAO_TARGETING_SCENE_LABELS,
  getToutiaoAdMarketingSceneByVersion,
  getToutiaoTargetingTypeByVersion
} from '@/views/promote/targeting/model/toutiao_targeting_consts.js'

const getTargetingMarketingScene = (targeting) =>
  targeting.targetingParamJson?.ad_marketing_scene || TOUTIAO_AD_MARKETING_SCENE.VERSION_2

export function useTargetingList(configForm, updateConfigForm, { isV3 } = {}) {
  const getCurrentMarketingScene = () => getToutiaoAdMarketingSceneByVersion(unref(isV3))
  const getDefaultTargetingType = () => getToutiaoTargetingTypeByVersion(unref(isV3))

  const targetings = reactive({
    targetingSelectModal: false,
    targetingSelectModalLoading: false,
    targetingTotal: 0,
    targetingList: [],
    showTargetingAddDrawer: false,
    toutiaoTargetingType: getDefaultTargetingType()
  })

  const onShowAddTargetingFormDrawer = () => {
    targetings.showTargetingAddDrawer = true
  }

  const onSelectConfirm = async (e) => {
    const selectableTargetings = e.filter((targeting) => getTargetingMarketingScene(targeting) === getCurrentMarketingScene())
    // 由于v--for的key使用的是targetingId，先清空所有定向包，不然相同的定向包id选择不会触发页面更新
    updateConfigForm({ ...configForm.value, targetings: [] })
    await nextTick()
    const targetings = clone(configForm.value.targetings)
    const selectedIds = selectableTargetings.map((i) => i.targetingId)
    const newTargetings = []

    // 获得老定向，且过滤掉当前已选定向
    const lagecyTargetings = targetings.filter((t) => !selectedIds.includes(t.targetingId))
    // 再把新定向添加进去
    newTargetings.push(...lagecyTargetings, ...selectableTargetings)

    // 最多选取100个
    updateConfigForm({
      ...configForm.value,
      targetings: newTargetings.slice(0, 100)
    })
  }
  const queryTargetingData = (filterParams) => {
    const { ch_platform_id } = configForm.value.project || {}
    let params = {
      mediaId: MEDIAS.TOUTIAO,
      platformId: ch_platform_id,
      adMarketingScene: targetings.toutiaoTargetingType,
      pageIndex: 1,
      pageSize: 10
    }
    if (filterParams) params = Object.assign({}, params, filterParams)

    targetings.targetingSelectModalLoading = true
    getTargetingData(params)
      .then((data) => {
        if (!data || typeof data === 'string') return
        const { list, page_info } = data
        if (list?.length && page_info) {
          const { total_number } = page_info
          targetings.targetingTotal = total_number || 0
          targetings.targetingList = list.map((targeting) => {
            const adMarketingScene = getTargetingMarketingScene(targeting)
            return {
              ...targeting,
              targetingTypeLabel: TOUTIAO_TARGETING_SCENE_LABELS[adMarketingScene]
            }
          })
        } else {
          targetings.targetingList = []
          targetings.targetingTotal = 0
        }
      })
      .finally(() => {
        targetings.targetingSelectModalLoading = false
      })
  }

  const isTargetingSelectable = (targeting) => getTargetingMarketingScene(targeting) === getCurrentMarketingScene()
  const resetTargetingType = () => {
    targetings.toutiaoTargetingType = getDefaultTargetingType()
  }

  return {
    ...toRefs(targetings),
    onShowAddTargetingFormDrawer,
    onSelectConfirm,
    queryTargetingData,
    isTargetingSelectable,
    resetTargetingType
  }
}
